import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaTariffService } from "src/app/modules/Disbursment_modules/master-tabs/pages/tariff-services/tariff-service.model";


@Injectable({
    providedIn: "root"
})
export class TariffService {

    constructor(private http: CommonHttpModule) { }

    // method to get all the service data from db
    serviceDataFromDb(): Observable<any> {
        return this.http.get("tariff-service", null, undefined);
    }

    // method to send the data to db
    ServiceDataToDB(data: MaTariffService): Observable<any> {
        return this.http.post("create-tariff-table", data).pipe(
            map((response) => {
                return response;
            })
        )
    }

    // method to get the particular service data
    serviceDataByServiceName(serviceName: string): Observable<{ data: any[]; total_count: number }> {
        const formattedService = serviceName.replace(/\s+/g, '').toLowerCase();
        return this.http.get<{ total_count: number, data: any[] }>(`tariff_service/${serviceName}`, null, undefined)
            .pipe(
                map(response => ({
                    total_count: response.total_count,
                    data: response.data
                }))
            );
    }

    createOrUpdateServiceData(serviceName: string, payloads: any[]): Observable<any> {
        const formattedService = serviceName.replace(/\s+/g, '').toLowerCase();
        console.log("service name", serviceName)
        return this.http.post<any>(`tariff_service/${serviceName}`, { data: payloads }).pipe(
            map(response => response)
        );
    }

}